module.exports = __webpack_public_path__ + "static/media/novedades.7b368bbf.png";